import { render, staticRenderFns } from "./live-item-hot2.vue?vue&type=template&id=3bbd8f33&scoped=true"
import script from "./live-item-hot2.vue?vue&type=script&lang=js"
export * from "./live-item-hot2.vue?vue&type=script&lang=js"
import style0 from "./live-item-hot2.vue?vue&type=style&index=0&id=3bbd8f33&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bbd8f33",
  null
  
)

export default component.exports